import { BlueShieldCheckmark as BlueShieldCheckmarkIcon } from 'phosphor-icons';
import { RichText } from '../RichText/RichText';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '../Tooltip/TooltipRadix';
import { CertifiedPublisherProps } from './types';

export const CertifiedPublisher = ({
  microcopy,
  className = '',
}: CertifiedPublisherProps) => {
  return (
    <Tooltip>
      <TooltipTrigger
        aria-label={microcopy.icon}
        className={className}
        data-test="certified-publisher-icon"
      >
        <BlueShieldCheckmarkIcon />
      </TooltipTrigger>

      <TooltipContent>
        <RichText
          html={microcopy.description}
          className="text-gray-400 text-sm [&_p]:mb-0"
        />
      </TooltipContent>
    </Tooltip>
  );
};
